import React, { useContext } from 'react';
import ConfigProvider from '../../Contexts/ConfigContext';
import { UnitsContext } from '../../Contexts/UnitsContext';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';

import Modalv2 from '../../Components/Modalv2';

//ConfigFiles
import OverviewConfig from './Components/OverviewConfig';
import PlayerSizeConfig from './Components/FormatData/PlayerSizeConfig';
import SiteConfig from './Components/SiteConfig';
import PrebidBiddersConfig from './Components/PrebidBiddersConfig';
import PlayerCustomCssConfig from './Components/FormatData/PlayerCustomCssConfig';
import CustomFloatConfig from './Components/FormatData/CustomFloatConfig';

import BatchedAdRequestsConfig from './Components/RequestStructureData/BatchedAdRequests';
import HbAdxSplitConfig from './Components/RequestStructureData/HbAdxSplitConfig';
import MaxUnfilledBeforeBackfillConfig from './Components/RequestStructureData/MaxUnfilledBeforeBackfillConfig';

import RequestBlockingConfig from './Components/RequestStructureData/RequestBlockingConfig';
import VideosConfig from './Components/VideoContent/VideosConfig';
import VideoSectionConfig from './Components/VideoSectionConfig';
import VideoAutoPlayConfig from './Components/FeaturesDataConfig/VideoAutoPlayConfig';
import FloatingUnitConfig from './Components/FeaturesDataConfig/FloatingUnitConfig';
import CustomStyleTagConfig from './Components/FormatData/CustomStyleTagConfig';
import OverlayClickBlockerConfig from './Components/FormatData/OverlayClickBlockerConfig';
import UamConfig from './Components/FeaturesDataConfig/UamConfig';
import DisableApLogoConfig from './Components/FeaturesDataConfig/DisableApLogoConfig';
import AutoSkipAdConfig from './Components/FeaturesDataConfig/AutoskipAdConfig';
import StopAfterCrossClickConfig from './Components/FeaturesDataConfig/StopAfterCrossClickConfig';
import ThumbnailUrlConfig from './Components/FeaturesDataConfig/ThumbnailUrlConfig';
import CustomLabelConfig from './Components/FeaturesDataConfig/CustomLabelConfig';
import CustomTargeting from './Components/FeaturesDataConfig/CustomTargeting';
import GamUprPlatformConfig from './Components/NetworkData/GamUprConfig';
import FpEngineConfig from './Components/NetworkData/FpEngineConfig';
import HbFloorsTab from './Components/RequestStructureData/HbFloorsTab';
import HbBidderTimeout from './Components/RequestStructureData/HbBidderTimeout';
import AdUnitsConfig from './Components/NetworkData/AdUnitsConfig';
import BtfRequestConfig from './Components/ExperimentalFeaturesData/BtfRequestConfig';
import IsAmpActiveTabRequestEnabledConfig from './Components/ExperimentalFeaturesData/IsAmpActiveTabRequestEnabledConfig';
import HbOnlySetupConfig from './Components/NetworkData/HbOnlySetupConfig';
import BgRequestConfig from './Components/ExperimentalFeaturesData/BgRequestConfig';
import LogAdditionalData from './Components/ExperimentalFeaturesData/LogAdditionalData';
import VideoCreativeProfile from './Components/ExperimentalFeaturesData/VideoCreativeProfile';
import PencilFloatConfig from './Components/FeaturesDataConfig/PencilFloatConfig';
import ViewPlayBack from './Components/FeaturesDataConfig/ViewPlayBack';
import VastDaisyChaining from './Components/FeaturesDataConfig/VastDaisyChaining';
import BannerReplacementConfig from './Components/FeaturesDataConfig/BannerReplacementConfig';
import VideoToBannerSwitchInContentConfig from './Components/FeaturesDataConfig/VideoToBannerSwitchInContentConfig';
import BackFillVastsConfig from './Components/FeaturesDataConfig/BackFillVastsConfig';
import FloatingOnlyConfig from './Components/FeaturesDataConfig/FloatingOnlyConfig';
import AdOnlyFloatingConfig from './Components/FeaturesDataConfig/AdOnlyFloatingConfig';
import InitialRequestDelay from './Components/RequestStructureData/InitialRequestDelay';
import CustomErrorRefresh from './Components/RequestStructureData/CustomErrorRefresh';
import AggressiveAdRequests from './Components/RequestStructureData/AggressiveAdRequests';
import DemandEngineConfig from './Components/NetworkData/DemandEngineConfig';
import CompanionAdsConfig from './Components/NetworkData/CompanionAds';
import OverlayAdsConfig from './Components/NetworkData/OverlayAds';
import HybridAdsConfig from './Components/NetworkData/HybridAds';
import CustomVastTagTabConfig from './Components/NetworkData/CustomVastTag';
import FinalOverview from './Components/FinalOverview';
import HBDecoupling from './Components/ExperimentalFeaturesData/HBDecoupling';
//===========

import UnitCreatorUi from './Components/UnitCreatorUi';
import GeneralButton from '../../Components/GeneralButton';

//mui imports====
import MergeTypeIcon from '@mui/icons-material/MergeType';
import Typography from '@mui/material/Typography';

import AdUnits from './Components/NetworkData/AdUnits';

import CustomPlacementParam from './Components/ExperimentalFeaturesData/CustomPlacementParam';
import UnmuteAfterInteractionOptimizationConfig from './Components/ExperimentalFeaturesData/UnmuteAfterInteractionOptimization';
import AggressiveUnmuteOptimization from './Components/ExperimentalFeaturesData/AggressiveUnmuteOptimization';
import FallbackTagConfig from './Components/FeaturesDataConfig/FallbackTagConfig';
import AudioContextPlayerVolume from './Components/ExperimentalFeaturesData/AudioContextPlayerVolume';
import AutoplayForIos from './Components/ExperimentalFeaturesData/AutoplayForIos';

import ConfigEditorMainPage from '../../Components/ConfigEditorMainPage';

//mui sidebar icons import
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import OndemandVideoOutlinedIcon from '@mui/icons-material/OndemandVideoOutlined';
import FormatAlignLeftOutlinedIcon from '@mui/icons-material/FormatAlignLeftOutlined';
import FilterDramaOutlinedIcon from '@mui/icons-material/FilterDramaOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import FeaturedPlayListOutlinedIcon from '@mui/icons-material/FeaturedPlayListOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import MaxAdDurationConfig from './Components/NetworkData/MaxAdDurationConfig';
import CtaCustomFeaturesConfig from './Components/VideoContent/CtaCustomFeaturesConfig';
import PageLevelContent from './Components/VideoContent/RssVideoGeneration';
import PageLevelContentVideosConfig from './Components/FeaturesDataConfig/PageLevelContentVideosConfig';
import { FEATURE_DESCRIPTION } from './constant';
import HbWithoutGamConfig from './Components/FeaturesDataConfig/HbWithoutGamConfig';
import AdRequestsRheostatConfig from './Components/FeaturesDataConfig/AdRequestsRheostatConfig';

//Config Components mapping object
const {
	NETWORK_DATA,
	REQUEST_STRUCTURE_DATA,
	FEATURES_DATA,
	VIDEO_CONTENT,
	EXPERIMENTAL_FEATURES_DATA,
	FORMAT_DATA,
	PREBID_SETTINGS
} = FEATURE_DESCRIPTION;
const { ACCESS_CONTROL_STRINGS } = ACCESS_CONTROL_CONSTANTS;
const settingAccessRequirements = {
	pageLevelContent: ACCESS_CONTROL_STRINGS.EXPERIMENTAL_FEATURES,
	pageLevelContentOverride: ACCESS_CONTROL_STRINGS.EXPERIMENTAL_FEATURES
};

const hasSettingAccess = (settingName, controlledAccess) => {
	const requiredAccess = settingAccessRequirements[settingName];
	return !requiredAccess || controlledAccess?.includes(requiredAccess);
};

//Config Components mapping object
const settingConfigs = {
	site: <SiteConfig />,
	'video-section': <VideoSectionConfig />,
	videos: <VideosConfig keyData="videos" featureDescription={VIDEO_CONTENT.VIDEO} />,
	ctaCustomFeaturesConfig: (
		<CtaCustomFeaturesConfig
			keyData="ctaCustomFeaturesConfig"
			featureDescription={VIDEO_CONTENT.CTA_CUSTOM_FEATURES}
		/>
	),
	pageLevelContent: (
		<PageLevelContent featureDescription={VIDEO_CONTENT.RSS_VIDEO_GENERATION.INFO} />
	),
	size: <PlayerSizeConfig featureDescription={FORMAT_DATA.PLAYER_SIZES} />,

	playerCustomCss: (
		<PlayerCustomCssConfig
			keyData="formatData.playerCustomCss"
			featureDescription={FORMAT_DATA.PLAYER_UI}
		/>
	),
	customFloatConfig: (
		<CustomFloatConfig
			keyData="formatData.customFloat"
			featureDescription={FORMAT_DATA.CUSTOM_FLOAT}
		/>
	),
	customStyleTagConfig: (
		<CustomStyleTagConfig
			keyData="formatData.customStyleTagConfig"
			featureDescription={FORMAT_DATA.CUSTOM_STYLE_TAG}
		/>
	),
	overlayClickBlockerConfig: (
		<OverlayClickBlockerConfig
			keyData="formatData.overlayClickBlockerConfig"
			featureDescription={FORMAT_DATA.OVERLAY_CLICK_BLOCKER}
		/>
	),
	adUnits: (
		<AdUnits keyData="networkData.dfpAdUnits" featureDescription={NETWORK_DATA.DFP_ADUNITS} />
	),
	gamUprTabConfig: (
		<GamUprPlatformConfig
			keyData="networkData.gamUprConfig"
			featureDescription={NETWORK_DATA.GAM_UPR_CONFIG}
		/>
	),
	fpEngineConfig: (
		<FpEngineConfig
			keyData="networkData.fpEngineConfig"
			featureDescription={NETWORK_DATA.FP_ENGINE}
		/>
	),
	hbFloorsTab: (
		<HbFloorsTab
			keyData="networkData.hbFloorsConfig"
			featureDescription={NETWORK_DATA.HB_FLOORS_CONFIG}
		/>
	),
	customVastTagConfig: (
		<CustomVastTagTabConfig
			keyData="networkData.customVastTag"
			featureDescription={NETWORK_DATA.CUSTOM_VAST_TAG}
		/>
	),
	prebidBiders: <PrebidBiddersConfig keyData="prebid" featureDescription={PREBID_SETTINGS} />,
	batchedAdRequests: (
		<BatchedAdRequestsConfig
			keyData="requestStructureData.batchedAdRequests"
			featureDescription={REQUEST_STRUCTURE_DATA.BATCHED_AD_REQUESTS}
		/>
	),
	hbAdxSplitConfig: (
		<HbAdxSplitConfig
			keyData="networkData.adxOnly"
			featureDescription={NETWORK_DATA.HB_ADX_SPLIT_CONFIG}
		/>
	),
	hbBidderTimeout: (
		<HbBidderTimeout
			keyData="networkData.hbBidderTimeout"
			featureDescription={NETWORK_DATA.HB_BIDDER_TIMEOUT}
		/>
	),
	adUnitsConfig: (
		<AdUnitsConfig
			keyData="networkData.adUnitsConfig"
			featureDescription={NETWORK_DATA.AD_UNITS_CONFIG}
		/>
	),
	demandEngineConfig: (
		<DemandEngineConfig
			keyData="networkData.demandEngineConfig"
			featureDescription={NETWORK_DATA.VAST_FE_CONFIG}
		/>
	),
	companionAdsConfig: (
		<CompanionAdsConfig
			keyData="networkData.apCompanionAds"
			featureDescription={NETWORK_DATA.COMPANION_ADS}
		/>
	),
	overlayAdsConfig: (
		<OverlayAdsConfig
			keyData="networkData.apOverlayAds"
			featureDescription={NETWORK_DATA.OVERLAY_ADS}
		/>
	),
	hybridAdsConfig: (
		<HybridAdsConfig
			keyData="networkData.apOutstreamHybridAds"
			featureDescription={NETWORK_DATA.HYBRID_ADS}
		/>
	),
	maxAdDuration: (
		<MaxAdDurationConfig
			keyData="networkData.maxAdDuration"
			featureDescription={NETWORK_DATA.MAX_AD_DURATION}
		/>
	),
	initialRequestDelay: (
		<InitialRequestDelay
			keyData="requestStructureData.initialRequestDelay"
			featureDescription={REQUEST_STRUCTURE_DATA.INITIAL_REQUEST_DELAY}
		/>
	),
	customErrorRefresh: (
		<CustomErrorRefresh
			keyData="requestStructureData.customErrorRefreshInterval"
			featureDescription={REQUEST_STRUCTURE_DATA.CUSTOM_ERROR_REFRESH}
		/>
	),
	maxUnfilledBeforeBackfillConfig: (
		<MaxUnfilledBeforeBackfillConfig
			keyData="requestStructureData.maxUnfilledBeforeBackfill"
			featureDescription={REQUEST_STRUCTURE_DATA.MAX_UNFILL_BEFORE_BACKFILL}
		/>
	),
	requestBlockingConfig: (
		<RequestBlockingConfig
			keyData="requestStructureData.countryWiseRequestBlocking"
			featureDescription={REQUEST_STRUCTURE_DATA.REQUEST_BLOCKING}
		/>
	),
	aggressiveAdRequests: (
		<AggressiveAdRequests
			keyData="requestStructureData.aggressiveAdRequests"
			featureDescription={REQUEST_STRUCTURE_DATA.SUBSEQUENT_AD_REQUESTS}
		/>
	),
	btfRequestConfig: (
		<BtfRequestConfig
			keyData="experimentalFeaturesData.btfRequestConfig"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.BTF_REQUEST_CONFIG}
		/>
	),
	isAmpActiveTabRequestEnabledConfig: (
		<IsAmpActiveTabRequestEnabledConfig
			keyData="experimentalFeaturesData.isAmpActiveTabRequestEnabled"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.AMP_ACTIVE_TAB}
		/>
	),
	hbOnlySetupConfig: (
		<HbOnlySetupConfig keyData="networkData.hbOnly" featureDescription={NETWORK_DATA.HB_ONLY} />
	),
	bgRequestConfig: (
		<BgRequestConfig
			keyData="experimentalFeaturesData.bgRequestConfig"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.BG_REQUEST_CONFIG}
		/>
	),
	logAdditionalData: (
		<LogAdditionalData
			keyData="experimentalFeaturesData.logAdditionalData"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.LOG_ADDITIONAL_DATA}
		/>
	),
	videoCreativeProfile: (
		<VideoCreativeProfile
			keyData="experimentalFeaturesData.videoCreativeProfile"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.VIDEO_CREATIVE_PROFILE}
		/>
	),
	customPlacementParam: (
		<CustomPlacementParam
			keyData="experimentalFeaturesData.customPlacementParam"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.CUSTOM_PLACEMENT_PARAM}
		/>
	),
	unmuteAfterInteractionOptimization: (
		<UnmuteAfterInteractionOptimizationConfig
			keyData="experimentalFeaturesData.unmuteAfterInteractionOptimization"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.ADVANCED_OPTIMIZATION}
		/>
	),
	aggressiveUnmuteOptimization: (
		<AggressiveUnmuteOptimization
			keyData="experimentalFeaturesData.aggressiveUnmuteOptimization"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.AGGRESSIVE_VPMUTE}
		/>
	),
	audioContextPlayerVolume: (
		<AudioContextPlayerVolume
			keyData="experimentalFeaturesData.audioContextPlayerVolume"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.AUDIO_CONTEXT_PLAYER_VOL}
		/>
	),
	autoplayForIos: (
		<AutoplayForIos
			keyData="experimentalFeaturesData.autoplayForIos"
			featureDescription={EXPERIMENTAL_FEATURES_DATA.AUTOPLAY_FOR_IOS}
		/>
	),
	videoAutoPlay: (
		<VideoAutoPlayConfig
			keyData="featuresData.videoAutoplay"
			featureDescription={FEATURES_DATA.VIDEO_AUTOPLAY}
		/>
	),
	floatingUnitConfig: (
		<FloatingUnitConfig
			keyData="featuresData.floatingUnitConfig"
			featureDescription={FEATURES_DATA.FLOATING_UNIT_CONFIG}
		/>
	),
	uamConfig: (
		<UamConfig keyData="featuresData.uamConfig" featureDescription={FEATURES_DATA.UAM_CONFIG} />
	),

	disableApLogoConfig: (
		<DisableApLogoConfig
			keyData="featuresData.disableApLogo"
			featureDescription={FEATURES_DATA.DISABLE_AP_LOGO}
		/>
	),
	autoskipAdConfig: (
		<AutoSkipAdConfig
			keyData="featuresData.autoSkipAd"
			featureDescription={FEATURES_DATA.AUTOSKIP_AD}
		/>
	),
	thumbnailUrlConfig: (
		<ThumbnailUrlConfig
			keyData="featuresData.thumbnailUrl"
			featureDescription={FEATURES_DATA.THUMBNAIL_URL}
		/>
	),
	customLabelConfig: (
		<CustomLabelConfig
			keyData="featuresData.customLabelConfig"
			featureDescription={FEATURES_DATA.CUSTOM_LABEL_CONFIG}
		/>
	),
	pencilFloatConfig: (
		<PencilFloatConfig
			keyData="featuresData.pencilFloatConfig"
			featureDescription={FEATURES_DATA.PENCIL_FLOAT_CONFIG}
		/>
	),
	customTargeting: (
		<CustomTargeting
			keyData="featuresData.customTargeting"
			featureDescription={FEATURES_DATA.CUSTOM_TARGETING}
		/>
	),
	backgroundViewPlayback: (
		<ViewPlayBack
			keyData="featuresData.backgroundViewPlayback"
			featureDescription={FEATURES_DATA.VIEW_PLAYBACK}
		/>
	),
	vastDaisyChainingConfig: (
		<VastDaisyChaining
			keyData="featuresData.vastDaisyChainingConfig"
			featureDescription={FEATURES_DATA.VAST_DAISY_CHAINING}
		/>
	),
	bannerReplacementConfig: (
		<BannerReplacementConfig
			keyData="featuresData.bannerReplacementConfig"
			featureDescription={FEATURES_DATA.BANNER_REPLACEMENT}
		/>
	),
	videoToBannerSwitchInContentConfig: (
		<VideoToBannerSwitchInContentConfig
			keyData="featuresData.bannerInContentAdConfig"
			featureDescription={FEATURES_DATA.VIDEO_TO_BANNER_SWITCH_IN_CONTENT}
		/>
	),
	backfillVastsConfig: (
		<BackFillVastsConfig
			keyData="featuresData.backfillVastsConfig"
			featureDescription={FEATURES_DATA.BACKFILL_VAST}
		/>
	),
	floatingOnlyConfig: (
		<FloatingOnlyConfig
			keyData="featuresData.floatingOnlySetup"
			featureDescription={FEATURES_DATA.FLOATING_ONLY_CONFIG}
		/>
	),
	adOnlyFloating: (
		<AdOnlyFloatingConfig
			keyData="featuresData.adOnlyFloating"
			featureDescription={FEATURES_DATA.AD_ONLY_FLOATING}
		/>
	),
	stopAfterCrossClickConfig: (
		<StopAfterCrossClickConfig
			keyData="featuresData.stopAfterCrossClick"
			featureDescription={FEATURES_DATA.STOP_AFTER_CROSS_CLICK}
		/>
	),
	fallbackTagConfig: (
		<FallbackTagConfig
			keyData="featuresData.fallbackTagConfig"
			featureDescription={FEATURES_DATA.FALLBACK_TAG_CONFIG}
		/>
	),
	hbWithoutGamConfig: (
		<HbWithoutGamConfig
			keyData="featuresData.hbWithoutGAM"
			featureDescription={FEATURES_DATA.HB_WITHOUT_GAM}
		/>
	),
	adRequestsRheostatConfig: (
		<AdRequestsRheostatConfig
			keyData="featuresData.rheostatConfig"
			featureDescription={FEATURES_DATA.AD_REQUESTS_RHEOSTAT}
		/>
	),
	hbDecoupling: (<HBDecoupling
			keyData="experimentalFeaturesData.hbDecoupling"
			featureDescription={FEATURES_DATA.HB_DECOUPLING}
		/>),
	pageLevelContentOverride: (
		<PageLevelContentVideosConfig
			keyData="featuresData.pageLevelContentVideos.disable"
			featureDescription={FEATURES_DATA.PAGE_LEVEL_CONTENT_VIDEOS}
		/>
	),
	overview: <OverviewConfig />
};

const UnitConfigGenerator = () => {
	const { curSelectedUnit, handlePullAndMergeSiteConfig } = useContext(UnitsContext);
	const { updateModalContent } = useContext(Modalv2Context);
	const { user } = useContext(UserContext);
	const controlledAccess = user?.controlledAccess;
	const visibleSettingConfigs = Object.fromEntries(
		Object.entries(settingConfigs).filter(([settingName]) => hasSettingAccess(settingName, controlledAccess))
	);

	const sidebarConfig = [
		{
			icon: <LanguageOutlinedIcon fontSize="medium" />,
			label: 'Site Settings',
			settingName: 'site'
		},
		{
			icon: <TextSnippetOutlinedIcon fontSize="medium" />,
			label: 'Prebid Settings',
			settingName: 'prebidBiders'
		},
		{
			icon: <OndemandVideoOutlinedIcon fontSize="medium" />,
			label: 'Page Level Content',
			settingName: 'pageLevelContent'
		},
		{
			icon: <VideoLibraryOutlinedIcon fontSize="medium" />,
			label: 'Video Section',
			settingName: 'video-section'
		},
		{
			icon: <OndemandVideoOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Video Content',
			name: 'VIDEO_CONTENT_ACCORDION',
			settings: [
				{
					label: 'Videos',
					settingName: 'videos'
				},
				{
					label: 'Cta Custom Features',
					settingName: 'ctaCustomFeaturesConfig'
				}
			]
		},
		{
			icon: <FormatAlignLeftOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Format Data',
			name: 'FORMAT_DATA_ACCORDION',
			settings: [
				{
					label: 'Player Sizes',
					settingName: 'size'
				},
				{
					label: 'Player UI',
					settingName: 'playerCustomCss'
				},
				{
					label: 'Custom Float',
					settingName: 'customFloatConfig'
				},
				{
					label: 'Custom Style Tag',
					settingName: 'customStyleTagConfig'
				},
				{
					label: 'Overlay Click Blocker',
					settingName: 'overlayClickBlockerConfig'
				}
			]
		},
		{
			icon: <FilterDramaOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Network Data',
			name: 'NETWORK_DATA_ACCORDION',
			settings: [
				{
					label: 'Dfp AdUnits',
					settingName: 'adUnits'
				},

				{
					label: 'Ad Units Config',
					settingName: 'adUnitsConfig'
				},
				{
					label: 'Gam Upr Config',
					settingName: 'gamUprTabConfig'
				},
				{
					label: 'Floor Price Moderator',
					settingName: 'fpEngineConfig'
				},
				{
					label: 'Hb Floors Config',
					settingName: 'hbFloorsTab'
				},
				{
					label: 'Hb Only',
					settingName: 'hbOnlySetupConfig'
				},
				{
					label: 'Custom Vast Tag',
					settingName: 'customVastTagConfig'
				},
				{
					label: 'Hb Adx Split Config',
					settingName: 'hbAdxSplitConfig'
				},
				{
					label: 'Hb Bidder Timeout',
					settingName: 'hbBidderTimeout'
				},
				{
					label: 'Vast FE Config',
					settingName: 'demandEngineConfig'
				},
				{
					label: 'Companion Ads',
					settingName: 'companionAdsConfig'
				},
				{
					label: 'Overlay Ads',
					settingName: 'overlayAdsConfig'
				},
				{
					label: 'Hybrid Ads',
					settingName: 'hybridAdsConfig'
				},
				{ label: 'Max Ad Duration', settingName: 'maxAdDuration' }
			]
		},
		{
			icon: <DnsOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Request Structure',
			name: 'REQUEST_STRUCTURE_DATA_ACCORDION',
			settings: [
				{
					label: 'Batched Ad Requests',
					settingName: 'batchedAdRequests'
				},
				{
					label: 'Request Blocking',
					settingName: 'requestBlockingConfig'
				},
				{
					label: 'Max Unfill Before Backfill',
					settingName: 'maxUnfilledBeforeBackfillConfig'
				},
				{
					label: 'Initial Request Delay',
					settingName: 'initialRequestDelay'
				},
				{
					label: 'Custom Error Refresh',
					settingName: 'customErrorRefresh'
				},
				{
					label: 'Sequential Ad Control',
					settingName: 'aggressiveAdRequests'
				}
			]
		},
		{
			icon: <ScienceOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Experiments',
			name: 'EXPERIMENTAL_FEATURES_DATA_ACCORDION',
			settings: [
				{
					label: 'Btf Request Config',
					settingName: 'btfRequestConfig'
				},
				{
					label: 'Amp Active Tab',
					settingName: 'isAmpActiveTabRequestEnabledConfig'
				},
				{
					label: 'Log Additional Data',
					settingName: 'logAdditionalData'
				},
				{
					label: 'Bg Request Config',
					settingName: 'bgRequestConfig'
				},
				{
					label: 'Video Creative Profile',
					settingName: 'videoCreativeProfile'
				},
				{
					label: 'CustomPlacement Param',
					settingName: 'customPlacementParam'
				},
				{
					label: 'Advanced Optimization',
					settingName: 'unmuteAfterInteractionOptimization'
				},
				{
					label: 'Aggressive Vpmute',
					settingName: 'aggressiveUnmuteOptimization'
				},
				{
					label: 'Audio Context Player Vol',
					settingName: 'audioContextPlayerVolume'
				},
				{
					label: 'Autoplay For Ios',
					settingName: 'autoplayForIos'
				},
				{
					label: 'HB Decoupling',
					settingName: 'hbDecoupling'
				}
			]
		},
		{
			icon: <FeaturedPlayListOutlinedIcon fontSize="medium" />,
			isAccordion: true,
			label: 'Features Data',
			name: 'FEATURES_DATA_ACCORDION',
			settings: [
				{
					label: 'Page Level Content Override',
					settingName: 'pageLevelContentOverride'
				},
				{
					label: 'Video Autoplay',
					settingName: 'videoAutoPlay'
				},
				{
					label: 'Floating Unit Config',
					settingName: 'floatingUnitConfig'
				},
				{
					label: 'Uam Config',
					settingName: 'uamConfig'
				},
				{
					label: 'Disable ApLogo',
					settingName: 'disableApLogoConfig'
				},
				{
					label: 'Autoskip Ad',
					settingName: 'autoskipAdConfig'
				},
				{
					label: 'Thumbnail Url',
					settingName: 'thumbnailUrlConfig'
				},
				{
					label: 'Custom Label Config',
					settingName: 'customLabelConfig'
				},
				{
					label: 'Pencil Float Config',
					settingName: 'pencilFloatConfig'
				},
				{
					label: 'Custom Targeting',
					settingName: 'customTargeting'
				},
				{
					label: 'View Playback',
					settingName: 'backgroundViewPlayback'
				},
				{
					label: 'Vast Daisy Chaining',
					settingName: 'vastDaisyChainingConfig'
				},
				{
					label: 'Banner Replacement',
					settingName: 'bannerReplacementConfig'
				},
				{
					label: 'Video Banner Switch',
					settingName: 'videoToBannerSwitchInContentConfig'
				},
				{
					label: 'Backfill Vast',
					settingName: 'backfillVastsConfig'
				},
				{
					label: 'Floating Only Config',
					settingName: 'floatingOnlyConfig'
				},
				{
					label: 'AdOnly Floating',
					settingName: 'adOnlyFloating'
				},
				{
					label: 'Stop After Cross-Click',
					settingName: 'stopAfterCrossClickConfig'
				},
				{
					label: 'Fallback Tag Config',
					settingName: 'fallbackTagConfig'
				},
				{
					label: 'HB Without GAM',
					settingName: 'hbWithoutGamConfig'
				},
				{
					label: 'Ad Requests Rheostat',
					settingName: 'adRequestsRheostatConfig'
				}
			]
		},
		{
			icon: <FindInPageOutlinedIcon fontSize="medium" />,
			label: 'Section Overview',
			settingName: 'overview'
		},

		{
			isButton: true,
			button: (
				<GeneralButton
					color="primary"
					variant="outlined"
					size="medium"
					endIcon={<MergeTypeIcon style={{ rotate: '180deg' }} />}
					onClick={handlePullAndMergeSiteConfig}
					name="INST_PULL_AND_MERGE_BUTTON"
				>
					<Typography fontWeight="bold">Pull Latest Version</Typography>
				</GeneralButton>
			)
		},
		{
			isButton: true,
			button: (
				<GeneralButton
					color="primary"
					variant="contained"
					size="medium"
					onClick={() => updateModalContent(<FinalOverview />)}
					name="INST_FINAL_OVERVIEW_BUTTON"
				>
					<Typography fontWeight="bold">Final Overview</Typography>
				</GeneralButton>
			)
		}
	];
	const visibleSidebarConfig = sidebarConfig
		.filter(({ settingName }) => hasSettingAccess(settingName, controlledAccess))
		.map((config) => {
			if (!config.settings) {
				return config;
			}

			return {
				...config,
				settings: config.settings.filter(({ settingName }) => hasSettingAccess(settingName, controlledAccess))
			};
		});	

	//============
	return (
		<ConfigProvider>
			<ConfigEditorMainPage
				sidebarConfig={visibleSidebarConfig}
				settingConfigs={visibleSettingConfigs}
				isLoading={!curSelectedUnit}
			/>
			<UnitCreatorUi />
			<Modalv2 />
		</ConfigProvider>
	);
};

export default UnitConfigGenerator;
